import React from "react";
import LegalLayout, { H2, P, UL } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" subtitle="Legal · 02" lastUpdated="February 2026">
      <P>
        This Privacy Policy describes how CAMO ("we", "us") collects, uses, and protects personal data in
        connection with our website and services. CAMO complies with the EU General Data Protection
        Regulation (Regulation 2016/679, "GDPR") and applicable Italian data protection law.
      </P>

      <H2>1. Data Controller</H2>
      <P>
        The data controller for processing is CAMO. For privacy enquiries, contact us via Discord
        (@felopic) or Instagram (@camointelligence).
      </P>

      <H2>2. Data We Collect</H2>
      <UL>
        <li><strong>Identification data:</strong> name, email address.</li>
        <li><strong>Communication data:</strong> messages submitted via contact forms.</li>
        <li><strong>Subscription data:</strong> selected plan, signup timestamps. Payments are processed by
          PayPal — we do not store card or bank details.</li>
        <li><strong>Technical data:</strong> IP address, browser type, device, pages viewed (via cookies/logs).</li>
      </UL>

      <H2>3. Purposes & Legal Basis</H2>
      <UL>
        <li><strong>Provide services</strong> (contract performance, Art. 6(1)(b) GDPR).</li>
        <li><strong>Process subscriptions</strong> via PayPal (contract, Art. 6(1)(b)).</li>
        <li><strong>Respond to enquiries</strong> (legitimate interest, Art. 6(1)(f)).</li>
        <li><strong>Comply with legal obligations</strong> (Art. 6(1)(c)) — tax, anti-money-laundering.</li>
        <li><strong>Marketing</strong> (consent, Art. 6(1)(a)) — only where you opt in.</li>
      </UL>

      <H2>4. Data Sharing</H2>
      <P>We do not sell personal data. We share data only with:</P>
      <UL>
        <li>PayPal (payment processor) — see PayPal's own privacy notice.</li>
        <li>Resend (transactional email provider) — for delivery of notifications.</li>
        <li>Hosting / infrastructure providers under data-processing agreements.</li>
        <li>Authorities, when required by law.</li>
      </UL>

      <H2>5. International Transfers</H2>
      <P>
        Some processors operate outside the European Economic Area. Where this occurs, transfers are
        protected by Standard Contractual Clauses or equivalent safeguards under Chapter V GDPR.
      </P>

      <H2>6. Retention</H2>
      <UL>
        <li>Membership / billing data: 10 years (Italian tax law).</li>
        <li>Contact form messages: 24 months from last interaction.</li>
        <li>Marketing consent: until withdrawn.</li>
      </UL>

      <H2>7. Your Rights (GDPR Arts. 15–22)</H2>
      <UL>
        <li>Access — request a copy of your data.</li>
        <li>Rectification — correct inaccurate data.</li>
        <li>Erasure ("right to be forgotten").</li>
        <li>Restriction or objection to processing.</li>
        <li>Data portability.</li>
        <li>Withdraw consent at any time.</li>
        <li>Lodge a complaint with the Italian Garante per la Protezione dei Dati Personali (or your local supervisory authority).</li>
      </UL>
      <P>To exercise any right, contact us via Discord or Instagram.</P>

      <H2>8. Security</H2>
      <P>
        We implement reasonable technical and organisational measures (encrypted transport, access
        controls, principle of least privilege) to protect personal data. No system is 100% secure.
      </P>

      <H2>9. Cookies</H2>
      <P>See our <a href="/legal/cookies" className="underline hover:text-white">Cookie Notice</a> for details on cookies and similar technologies.</P>

      <H2>10. Updates</H2>
      <P>We may update this Policy. Material changes will be announced on the Site.</P>
    </LegalLayout>
  );
}
